import React from 'react';
import { Linkedin, Github, Mail, BookOpen, MapPin, FileText, ArrowUpRight, Clock } from 'lucide-react';
import PageHead from '../components/PageHead';
import { profile } from '../data/portfolio';

const Contact = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 pb-8">
      <PageHead eyebrow="Contact" title="Let's build reliable platforms, together" />

      <p className="text-[16px] text-ink-soft mt-2 mb-10 max-w-2xl leading-relaxed">
        I'm currently on a deliberate career break after my most recent role as Vice President — SRE at
        JPMorgan Chase, and{' '}
        <span className="text-brand font-medium">available immediately</span> for the right VP / Head of
        SRE & Platform Engineering opportunity. Open to advisory engagements, mentorship, and speaking as well.
        The fastest way to reach me is email or LinkedIn.
      </p>

      <div className="grid gap-4 md:grid-cols-2">
        <a
          href={profile.socials.email}
          className="group rounded-xl border border-border p-6 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-lg border border-border flex items-center justify-center text-brand shrink-0">
            <Mail size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute">Email</div>
            <div className="text-[15px] font-medium mt-1 truncate group-hover:text-brand transition-colors">
              {profile.emailAddr}
            </div>
            <div className="text-[12.5px] text-ink-mute mt-2">Opens your mail client</div>
          </div>
          <ArrowUpRight
            size={16}
            className="text-ink-mute group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform shrink-0"
          />
        </a>

        <a
          href={profile.socials.emailResume}
          className="group rounded-xl border border-brand/40 p-6 bg-brand/5 hover:bg-brand/10 hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-lg bg-brand text-black flex items-center justify-center shrink-0">
            <FileText size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mono uppercase tracking-widest text-[10.5px] text-brand">Request Resume</div>
            <div className="text-[15px] font-medium mt-1 group-hover:text-brand transition-colors">
              Send a short note & I'll share
            </div>
            <div className="text-[12.5px] text-ink-mute mt-2">Prefilled email — resume shared privately</div>
          </div>
          <ArrowUpRight
            size={16}
            className="text-ink-mute group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform shrink-0"
          />
        </a>

        <a
          href={profile.socials.linkedin}
          target="_blank"
          rel="noreferrer"
          className="group rounded-xl border border-border p-6 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-lg border border-border flex items-center justify-center text-ink-soft group-hover:text-brand shrink-0">
            <Linkedin size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute">LinkedIn</div>
            <div className="text-[15px] font-medium mt-1 group-hover:text-brand transition-colors">
              /in/veeresh-wali
            </div>
            <div className="text-[12.5px] text-ink-mute mt-2">Connect & message directly</div>
          </div>
          <ArrowUpRight
            size={16}
            className="text-ink-mute group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform shrink-0"
          />
        </a>

        <a
          href={profile.socials.github}
          target="_blank"
          rel="noreferrer"
          className="group rounded-xl border border-border p-6 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-lg border border-border flex items-center justify-center text-ink-soft group-hover:text-brand shrink-0">
            <Github size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute">GitHub</div>
            <div className="text-[15px] font-medium mt-1 group-hover:text-brand transition-colors">
              @wali-veer
            </div>
            <div className="text-[12.5px] text-ink-mute mt-2">Projects & automation samples</div>
          </div>
          <ArrowUpRight
            size={16}
            className="text-ink-mute group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform shrink-0"
          />
        </a>

        <a
          href={profile.socials.goodreads}
          target="_blank"
          rel="noreferrer"
          className="group rounded-xl border border-border p-6 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-start gap-4"
        >
          <div className="w-11 h-11 rounded-lg border border-border flex items-center justify-center text-ink-soft group-hover:text-brand shrink-0">
            <BookOpen size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute">Goodreads</div>
            <div className="text-[15px] font-medium mt-1 group-hover:text-brand transition-colors">
              Reading shelf
            </div>
            <div className="text-[12.5px] text-ink-mute mt-2">What I'm reading & recommend</div>
          </div>
          <ArrowUpRight
            size={16}
            className="text-ink-mute group-hover:text-brand group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform shrink-0"
          />
        </a>

        <div className="group rounded-xl border border-border p-6 bg-card/40 hover:bg-card/70 hover:border-brand/60 hover:shadow-lg hover:-translate-y-0.5 transition-all flex items-start gap-4">
          <div className="w-11 h-11 rounded-lg border border-border flex items-center justify-center text-ink-soft group-hover:text-brand shrink-0">
            <MapPin size={18} />
          </div>
          <div className="min-w-0 flex-1">
            <div className="mono uppercase tracking-widest text-[10.5px] text-ink-mute">Based in</div>
            <div className="text-[15px] font-medium mt-1">Hyderabad, India</div>
            <div className="text-[12.5px] text-ink-mute mt-2 inline-flex items-center gap-1.5">
              <Clock size={12} /> IST (UTC +5:30) · Open to relocation
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
